// WallCTA.jsx - Shared component for displaying CTA in wall view
import anime from 'animejs';
import React, { useEffect, useRef } from 'react';

export const WallCTA = ({ wallData = {}, arrowIconSrc = '/media/icons/ph-fill/share-fat-fill.svg' }) => {
  const wallDropShadowStyle =
    wallData?.wallSettings?.dropShadowStyle ||
    'drop-shadow-[0_0_1rem_rgba(0,0,0,0.25)]';
  const addDebugStyle = wallData?.addDebugStyle || '';
  const refCTAArrow = useRef(null);

  // Hide CTA when backgroundOnly is true (for QR code displays)
  const backgroundOnly = wallData?.wallMessage?.postItem?.backgroundOnly ?? false;
  const ctaShow = backgroundOnly
    ? false
    : (wallData?.wallSettings?.wallCTA?.ctaShow ?? true);
  const ctaAnimation =
    wallData?.wallSettings?.wallCTA?.ctaAnimation || 10000;
  const caption = wallData?.wallSettings?.ctaCTA || '';
  const urlNoProt = wallData?.wallCTA?.urlNoProt || 'pipeup.live';

  useEffect(() => {
    if (ctaAnimation > 0) {
      anime({
        targets: refCTAArrow.current,
        keyframes: [
          {
            duration: ctaAnimation,
          },
          {
            opacity: 1,
            rotate: '20deg',
            scale: 2.5,
            duration: 1000,
            easing: 'easeOutQuart',
          },
          {
            opacity: 0,
            scale: 1,
            rotate: '0',
            translateY: '0',
            translateX: '0',
            duration: 250,
            easing: 'easeInQuart',
          },
        ],
        loop: true,
      });
    }
  }, [ctaAnimation]);

  const wallTextColor = 'text-white';
  const wallFilterColor = 'filter-(--filter-white)';
  const wallCTAStyle = `z-30 absolute bottom-1/32 right-1/32 w-30/32 transition-all ${ctaShow ? "opacity-100" : "opacity-0"}`;

  return (
    <div
      id="wallCTA"
      className={[
        wallCTAStyle,
        wallTextColor,
        wallDropShadowStyle,
        addDebugStyle,
      ].join(' ')}
    >
      <div className="flex flex-col items-end justify-start gap-0">
        <img
          ref={refCTAArrow}
          className={[
            wallFilterColor,
            'absolute -top-full mt-[2vmin] -mr-2 size-[4vmin] origin-bottom-left -scale-x-100 rotate-60 opacity-0',
          ].join(' ')}
          src={arrowIconSrc}
          alt=""
        />

        <div className="flex items-baseline font-black">
          {caption && (
            <span className="pr-[0.5em] text-[4vmin] leading-none">
              {caption}
            </span>
          )}
          <a
            href="#"
            className="text-[7vmin] leading-none cursor-none transition-all"
          >
            {urlNoProt}
          </a>
        </div>
      </div>
    </div>
  );
};
